import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import _IconDown from "@arco-design/web-react/icon/react-icon/IconDown";
import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import _IconLink from "@arco-design/web-react/icon/react-icon/IconLink";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import Union from '@/assets/union.png';
import IconButton from './IconButton';
import Settings from '../Settings';
import styles from './style/index.module.less';
import useStorage from '@/utils/useStorage';
import { GetMchCompIncomeRelationList, MchSwitchIncome } from '@/utils/service';
import constant from '@/utils/constant';
import NavBarRelationMchAdmin from '@/components/NavBarRelationMchAdmin';
import OemLogo from '@/components/OemLogo';

function Navbar({
  show
}) {
  const t = useLocale();
  const userInfo = useSelector(state => state.userInfo);
  const [_, setUserStatus] = useStorage('userStatus');
  const [relationMchList, setRelationMchList] = useState([]);
  const [showRelationMchAdmin, setShowRelationMchAdmin] = useState(false);
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);

  function GetMchRelationList() {
    if (userInfo.role == constant.RoleMch) {
      GetMchCompIncomeRelationList().then(res => {
        if (res.data) {
          const {
            code,
            data,
            msg
          } = res.data;

          if (code === constant.SysSuc) {
            const ml = [];

            for (const i in data) {
              if (data[i].id !== userInfo.income) {
                ml.push(data[i]);
              }
            }

            const configOrder = JSON.parse(localStorage.getItem('config.order') || '[]');
            const relationMchOrderedList = [];

            for (const i in configOrder) {
              let c = undefined;

              for (const j in ml) {
                const orderIncomeId = configOrder[i];

                if (ml[j].id == orderIncomeId) {
                  ml[j].order = parseInt(i);
                  c = ml[j];
                  continue;
                }
              }

              if (c) relationMchOrderedList.push(c);
            } //如果数据长度不匹配就以此补充


            if (relationMchOrderedList.length !== ml.length) {
              for (const j in ml) {
                let exist = false;

                for (const i in relationMchOrderedList) {
                  if (relationMchOrderedList[i].id == ml[j].id) {
                    exist = true;
                  }
                }

                if (!exist) relationMchOrderedList.push(ml[j]);
              }
            } //撮合新的config数据 做好排序, 排序变更时，也要更新config


            setRelationMchList(relationMchOrderedList);
          }
        }
      });
    }
  }

  function logout() {
    setUserStatus('logout');
    window.location.href = '/login';
  }

  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    } else if (key === 'admin') {
      setShowRelationMchAdmin(true);
    } else {
      MchSwitchIncome(key).then(res => {
        if (res.data) {
          const {
            code,
            data,
            msg
          } = res.data;

          if (code === constant.SysSuc) {
            _Message.success('商户切换成功');

            setTimeout(() => window.location.reload(), 500);
          } else {
            _Message.error(msg);
          }
        }
      });
    }
  }

  function onClickAdminMch() {
    setShowRelationMchAdmin(true);
  }

  function onClickLogout() {
    logout();
  }

  if (!show) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['fixed-settings']
    }, /*#__PURE__*/React.createElement(Settings, {
      trigger: /*#__PURE__*/React.createElement(_Button, {
        icon: /*#__PURE__*/React.createElement(_IconSettings, null),
        type: "primary",
        size: "large"
      })
    }));
  }

  const dropDownVisibleChange = show => {
    if (show) {
      GetMchRelationList();
    }
  };

  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick
  }, /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), relationMchList.map((mch, index) => {
    if (index > 2) return;
    return /*#__PURE__*/React.createElement(_Menu.Item, {
      key: mch.id
    }, /*#__PURE__*/React.createElement(_IconLink, {
      className: styles['dropdown-icon']
    }), mch.reg_name);
  }), userInfo.role == constant.RoleMch && relationMchList.length ? /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: 8
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    onClick: onClickAdminMch
  }, "\u7BA1\u7406\u5546\u6237"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 25
    }
  }), /*#__PURE__*/React.createElement(_Button, {
    onClick: onClickLogout
  }, t['navbar.logout']))) : /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_Button, {
    onClick: onClickLogout
  }, t['navbar.logout'])));

  const showAgent = () => {
    if (userInfo.role == constant.RoleAgent) {
      return true;
    } else if (userInfo.role == constant.RoleMch) {
      return userInfo.groupShow == 1;
    } else return userInfo.role == constant.RoleRoot;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(OemLogo, null), showAgent() ? /*#__PURE__*/React.createElement("img", {
    src: Union,
    style: {
      width: 42,
      paddingRight: 15,
      paddingLeft: 5
    }
  }) : null, showAgent() ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 20,
      color: theme == 'dark' ? '#FFF' : '#000'
    }
  }, userInfo?.groupName || userInfo?.realname) : null)), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Tooltip, {
    content: theme === 'light' ? t['settings.navbar.theme.toDark'] : t['settings.navbar.theme.toLight']
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  }))), userInfo && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Dropdown, {
    onVisibleChange: dropDownVisibleChange,
    droplist: droplist,
    position: "br"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '16px',
      color: theme == 'dark' ? '#FFF' : '#000'
    }
  }, userInfo.incomeInfo?.regName || userInfo.realname), "\xA0", /*#__PURE__*/React.createElement(_IconDown, {
    style: {
      color: theme == 'dark' ? '#FFF' : '#000'
    }
  }))), showRelationMchAdmin && !!relationMchList.length ? /*#__PURE__*/React.createElement(NavBarRelationMchAdmin, {
    name: userInfo.incomeInfo?.regName || userInfo.realname,
    switchIncome: onMenuItemClick,
    show: showRelationMchAdmin && !!relationMchList.length,
    unShow: () => setShowRelationMchAdmin(false),
    relationMchList: relationMchList,
    setRelationMchList: setRelationMchList
  }) : null));
}

export default Navbar;